import { InstrumentPanel } from 'lib-analytics-types';

/**
 * Sort the panels by their layout coordinates, so that their order in the list
 * matches their position on the grid. The panels are sorted first by their y
 * coordinate, then by their x coordinate.
 *
 * This is important to ensure that the tabIndex order is correct, as well as
 * that the panels are rendered in the correct order when stacked vertically on
 * smaller screens where their y and x coordinates are overwritten.
 */
export const sortPanels = (a: InstrumentPanel, b: InstrumentPanel): number => {
  // Sort by y-coordinate first (ascending)
  if (a.layout.y === b.layout.y) {
    // If y-coordinates are equal, sort by x-coordinate (ascending)
    return a.layout.x - b.layout.x;
  }
  return a.layout.y - b.layout.y;
};
